"use client";

import { hasArrayElements } from "@/apiUtils/commonUtils";
import { CLink } from "@/components/common/customLink/CustomLink";
import FeaturedProducts from "@/components/home/featuredProducts/FeaturedProducts";
import Button from "@/components/ui/button/Button";
// import Image from "next/image";
import NoImageSrc from "@/assets/images/no_image.svg";
import { getCloudinaryURL } from "@/utils/cloudinary";
import { getFieldValue, getLangFromLocale } from "@/utils/common";
import { useParams } from "next/navigation";
import { SingleImageBannerProps } from "../types";
// import { SanityImg } from "@/components/ui/SanityImg/SanityImg";
import CtaWidget from "@/components/common/CtaWidget";
import Image from "@/components/ui/imageV2/ImageV2";

const SingleImageBanner: React.FC<SingleImageBannerProps> = ({
  image,
  mobileImage,
  ctaConfig,
  ctaEnabled = false,
  type,
  featuredProducts,
  ctaSection
}: SingleImageBannerProps) => {
  const { locale } = useParams();
  const lang = getLangFromLocale(locale as string);


  return (
    <div className="relative">
      {ctaEnabled && (
        <Button
          variant={ctaConfig?.variant}
          className="absolute left-[50%] top-[90%] -translate-x-1/2 -translate-y-1/2 px-7 py-3 focus:border-2 md:left-[75%] md:top-[74%] md:px-12 md:py-3"
        >
          {ctaConfig?.label}
        </Button>
      )}
      <CLink href={ctaConfig?.url ?? ""}>
        <Image
          src={getCloudinaryURL(image) ?? NoImageSrc}
          alt={getFieldValue(lang, "Promotional Banner", "لافتة ترويجية") ?? "Promotional Banner"}
          className="hidden aspect-[1.95/1] w-full object-cover md:block"
          width={1440}
          height={738}
        />
        <Image
          src={getCloudinaryURL(mobileImage) ?? NoImageSrc}
          alt={getFieldValue(lang, "Promotional Banner", "لافتة ترويجية") ?? "Promotional Banner"}
          className="block aspect-[375/482] w-full object-cover md:hidden"
          width={375}
          height={482}
        />
      </CLink>
      {type === "featured" && featuredProducts && hasArrayElements(featuredProducts?.items) ? (
        <div dir="ltr" className="absolute bottom-0 w-full md:bottom-14 md:left-[5%] md:block">
          <FeaturedProducts content={featuredProducts} />
        </div>
      ) : (
        <></>
      )}
      {type === "cta" ? <CtaWidget content={ctaSection} locale={locale as string} /> : <></>}
    </div>
  );
};

export default SingleImageBanner;
